<template>
  <div class="bg-card border-border rounded-md border px-5 pt-3.5">
    <slot />
  </div>
</template>
